export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11243.ac0b95fc.jpg";